<section>
    <div class="wrapper">
        <article class="mrt-75" style="overflow: auto !important;min-height: calc(100vh - 117px);"  *ngIf="!isPageError">
            <div>
                <div class="content">
                    <div class="main-action-col" style="margin-bottom: 10px;padding: 1px;">
                        <div style="padding-left: 15px; padding-right: 15px; margin-left: auto; margin-right: auto;">
                            <div class="row">
                                <div class="col-sm-5">
                                    <h2 class="title">Site Data</h2>
                                </div>        
                            </div>
                        </div>
                    </div>
                </div>
                <div style="text-align: right; margin-bottom: 0.5rem;
                justify-content: flex-end;" class="responsive">
                    <div class="header-section">
                        <div class="dropdown">
                            <div class="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-bars"></i>
                            </div>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <div class="checkbox-list">
                                    <label style="font-weight: bold;">
                                        <input type="checkbox" [(ngModel)]="selectAll"
                                            (change)="toggleAllColumns(selectAll)"> Select all
                                    </label>
                                    <label *ngFor="let column of getColumnVisibilityKeys()" class="col-lable">
                                        <input type="checkbox" [(ngModel)]="columnVisibility[column]"
                                            (change)="onColumnVisibilityChange(column)"
                                            [disabled]="isColumnRestricted(column)" class="col-disable"> {{ column }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <select class="mrl_20 cursor" name="siteType" id="siteType" (change)="applyFilter($event)"
                        placeholder="Site Type" [(ngModel)]="siteType">
                        <option value="">Site Type - All</option>
                        <option value="Mobile">Mobile</option>
                        <option value="Fixed">Fixed</option>
                    </select>

                    <input type="text" (input)="applyFilter($event)" (keydown.enter)="applyFilter($event)"
                        placeholder="Search" [(ngModel)]="searchFilter" class="mrl_20" />
                    <select class="mrl_20 cursor" name="status" id="status" (change)="applyFilter($event)"
                        [(ngModel)]="siteFilter">
                        <option value="">Status - All</option>
                        <option value="2">UP</option>
                        <option value="0">DOWN</option>
                        <option value="1">PSD</option>
                        <option value="3">PAUSED</option>
                    </select>
                    <a *ngIf="filteredSiteData?.length > 0" [href]="csvPath" class="mrl_20"><i
                            class="material-icons" matTooltip="Download CSV"
                            style="position: relative;top: 8px; cursor: pointer;">file_download
                        </i></a>
                </div>
                <div class="pd" *ngIf="filteredSiteData?.length > 0">
                    <div class="overflow">
                        <table class="table table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" (click)="sortItems('potentialId', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Potential ID</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th scope="col" (click)="sortItems('parentAccountName', booleanValue)"
                                        class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Customer</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th scope="col" (click)="sortItems('siteName', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Location</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th scope="col" (click)="sortItems('unitId', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Site ID/ Unit ID</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Onboarded Date']" scope="col"
                                        (click)="sortItems('scheduledInstallDate', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Onboarded Date</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Opp.Installed Date']" scope="col"
                                    (click)="sortItems('stageInstallDate', booleanValue)" class="col-center">
                                    <div class="d-flex align-items-center center width">
                                        <span>Opp.Installed Date</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Site Info']" scope="col"
                                        (click)="sortItems('siteInfoLink', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Site Info</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th scope="col" (click)="sortItems('solarState', booleanValue)"
                                        *ngIf="siteType == 'Mobile'" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Power Source</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Site IP']" scope="col"
                                        (click)="sortItems('ipaddress', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Site IP</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Interval']" scope="col"
                                        (click)="sortItems('interval', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Interval (Sec)</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Status']" scope="col"
                                        (click)="sortItems('status', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Status</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Installed Status']" scope="col"
                                        (click)="sortItems('installedStatus', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Installed Status</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Opportunity Stage']" scope="col"
                                    (click)="sortItems('stage', booleanValue)" class="col-center">
                                    <div class="d-flex align-items-center center">
                                        <span>Opportunity Stage</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Message']" scope="col"
                                        (click)="sortItems('message', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Message</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Status Duration']" scope="col"
                                        (click)="sortItems('statusDuration', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Status Duration</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                    <th *ngIf="columnVisibility['Time Stamp']" scope="col"
                                        (click)="sortItems('createdDate', booleanValue)" class="col-center">
                                        <div class="d-flex align-items-center center">
                                            <span>Time Stamp(CT)</span>
                                            <div class="pl-2">
                                                <div class="arrow-section"><i class="arrow up"></i></div>
                                                <div class="arrow-section"><i class="arrow down"></i></div>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let sitedata of filteredSiteData | paginate: { itemsPerPage: ipP, currentPage: p, totalItems: total}; let i = index;">
                                    <td class="text-center">
                                        <span *ngIf="sitedata.serverUrl.indexOf('8443/pro-vigil') === -1 ">
                                            {{sitedata.potentialId}}
                                        </span>
                                        <a [attr.href]="sitedata.serverUrl"
                                            *ngIf="sitedata.serverUrl.indexOf('8443/pro-vigil') >=0"
                                            target="_blank">{{sitedata.potentialId}}</a>
                                    </td>
                                    <td class="text-center">
                                        <span
                                            *ngIf="sitedata.parentAccountName && sitedata.parentAccountName !== '-'">{{sitedata.parentAccountName}}</span>
                                        <span
                                            *ngIf="sitedata.parentAccountName == null || sitedata.parentAccountName == '' || sitedata.parentAccountName == '-'"
                                            class="text-center">N/A</span>
                                    </td>
                                    <td> <a style="color:dodgerblue;margin-right:10px;font-size:15px;cursor: pointer"
                                            (click)="openDashboard(sitedata)"><u>{{sitedata.siteName}}</u></a></td>
                                    <td class="text-center">{{sitedata.unitId}}</td>
                                    <td *ngIf="columnVisibility['Onboarded Date']" class="text-center">{{
                                        sitedata.scheduledInstallDate ? formatDate(sitedata.scheduledInstallDate) :
                                        'N/A' }}</td>
                                    <td *ngIf="columnVisibility['Opp.Installed Date']" class="text-center">{{ sitedata?.stageInstallDate !== '-' ? formatStageDate(sitedata?.stageInstallDate) : 'N/A' }}</td>
                                    <td *ngIf="columnVisibility['Site Info']" class="text-center">
                                        <a *ngIf="sitedata.siteInfoLink && sitedata.siteInfoLink !== '-'"
                                            [attr.href]="sitedata.siteInfoLink" target="_blank">Link</a>
                                        <span *ngIf="!sitedata.siteInfoLink || sitedata.siteInfoLink == '-'">N/A</span>
                                    </td>
                                    <td *ngIf="siteType == 'Mobile'" class="text-center">{{sitedata.solarState ? 'Solar
                                        Power' : 'Main Power'}}</td>
                                    <td *ngIf="columnVisibility['Site IP']" class="text-center">{{sitedata.ipaddress ?
                                        sitedata.ipaddress : 'N/A'}}</td>
                                    <td *ngIf="columnVisibility['Interval']" class="text-center">{{sitedata.interval ?
                                        sitedata.interval : 'N/A'}}</td>
                                    <td *ngIf="columnVisibility['Status']" class="text-center">
                                        <span
                                            *ngIf="sitedata.status.toLowerCase() == 'up' && sitedata.installedStatus !== 'Pause Service'"
                                            class="up-status"></span>
                                        <span
                                            *ngIf="sitedata.status.toLowerCase() == 'down' && sitedata.installedStatus !== 'Pause Service'"
                                            class="down-status"></span>
                                        <span
                                            *ngIf="sitedata.status === 'Not Monitoring' && sitedata.installedStatus !== 'Pause Service'"
                                            class="monitor-status">
                                        </span>
                                        <span
                                            *ngIf="sitedata.status.toLowerCase() == 'partialdown' && sitedata.installedStatus !== 'Pause Service'"
                                            class="partial-status"></span>
                                        <span *ngIf="sitedata.installedStatus == 'Pause Service'"
                                            class="pause-status"></span>
                                    </td>
                                    <td *ngIf="columnVisibility['Installed Status']" class="text-center">
                                        {{sitedata.installedStatus}}</td>
                                    <td *ngIf="columnVisibility['Opportunity Stage']" class="text-center">{{ sitedata?.stage !== '-' ? sitedata.stage : 'N/A' }}</td>
                                    <td *ngIf="columnVisibility['Message'] && sitedata.installedStatus !== 'Pause Service'"
                                        class="text-center">{{sitedata.status !== 'Not Monitoring' ? sitedata.message : 'Not Monitoring'}}</td>
                                    <td *ngIf="columnVisibility['Message'] && sitedata.installedStatus == 'Pause Service'"
                                        class="text-center">Paused</td>
                                    <td *ngIf="columnVisibility['Status Duration']" class="text-center">
                                        {{sitedata.statusDuration}}</td>
                                    <td *ngIf="columnVisibility['Time Stamp']" class="text-center">
                                        {{sitedata.createdDate}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="footer-section">
                        <span class="mr-3"><b>Items per page:</b>{{ipP}}</span>
                        <span><b>{{100 * p - ipP + 1}} - {{(size !== ipP) ? total : (100 * p) }}</b> of
                            <b>{{total}}</b></span>
                        <pagination-controls (pageChange)="p = $event; getNewItems(p);"></pagination-controls>
                    </div>
                </div>
            </div>
            <div *ngIf="filteredSiteData.length == 0" class="no-data text-primary">
                <div id="no-data-found">
                    {{loadingUserMessage}}
                </div>
            </div>
        </article>
        <article *ngIf="isPageError" class="site-page-error">
            <p class="site-page-errorMsg page-load">{{pageLoadMessage}}</p>
        </article>
    </div>
</section>